import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Btn from '../../Btn';
import config from '../../../config';
import authHeaders from '../../../utilities/authHeaders';
import { useStore } from '../../../StoreProvider';
import { ACTIONS } from '../../../Actions';
import convertJSON from '../../../utilities/convertJSON';

const Zaeger = ({freightRules, markup}) => {
    const { state, dispatch } = useStore();
    const headers = authHeaders(state?.auth.accessToken, state?.auth.refreshToken);
    const [z_filter_price_per_cubic_yard, set_z_filter_price_per_cubic_yard] = useState(
        freightRules.zaeger_filter_price_per_cubic_yard
    );
    const [z_ewf_price_per_cubic_yard, set_z_ewf_price_per_cubic_yard] = useState(
        freightRules.zaeger_ewf_price_per_cubic_yard
    );

    const zaeger = {
        title: 'Zaeger',
        names: ['Manufacturer', 'EWF Price Per Cubic Yard', 'Filter Price Per Cubic Yard', 'Freight Markup'],
    };
    const colSpanLength = zaeger.names.length;

    let idArray = ['zaeger_ewf_price_per_cubic_yard', 'zaeger_filter_price_per_cubic_yard'];

    let putBody = {};

    const putInput = async () => {
        for (let e = 0; e < idArray.length; e++) {
            var inputID = idArray[e];
            var inputValue = document.getElementById(inputID).value;

            putBody[inputID] = inputValue;
        }

        try {
            const res = await fetch(`${config.base_api}/freightRules`, {
                method: 'PUT',
                headers,
                body: JSON.stringify(putBody),
            });

            await convertJSON(res);

            dispatch({ type: ACTIONS.TOAST, payload: {message: 'Zaeger Updated'}});
        } catch (error) {
            dispatch({ type: ACTIONS.TOAST, payload: {message: error, isError: true}});
        }
    };

    return (
        <form className="freightGroup">
            <div className="quotesTable">
                <table>
                    <thead>
                        <tr>
                            {zaeger.names.map((name) => (
                                <th>{name}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{zaeger.title}</td>
                            <td>
                                <input
                                    id="zaeger_ewf_price_per_cubic_yard"
                                    defaultValue={z_ewf_price_per_cubic_yard}
                                    onChange={(e) => set_z_ewf_price_per_cubic_yard(e.target.value)}></input>
                            </td>
                            <td>
                                <input
                                    id="zaeger_filter_price_per_cubic_yard"
                                    defaultValue={z_filter_price_per_cubic_yard}
                                    onChange={(e) => set_z_filter_price_per_cubic_yard(e.target.value)}></input>
                            </td>
                            <td>
                                <input value={markup} disabled="true"></input>
                            </td>
                        </tr>
                        <tr className="equation">
                            <td colspan={colSpanLength}>
                                Calculations: <br />
                                EWF: (Cubic Yards x ${z_ewf_price_per_cubic_yard}) / {markup} <br />
                                Filter: (Ceiling[Cubic Yards / 50] x ${z_filter_price_per_cubic_yard}) / {markup}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <Btn title="Update" onClick={putInput} 
                btnClass = 'blue-button b2-blue text-white bg-blue text-bold box-shadow pad-tb-sm'/>
            </div>
        </form>
    );
};

export default Zaeger;
